import styled, { css } from "styled-components";

export const GiftCardSegmentRoot = styled.div(
    () => css`
        margin-bottom: 20px;
    `,
);

export const ImgGiftCard = styled.img(
    () => css`
        width: 100%;
        height: 110px;
        object-fit: contain;
    `,
);

export const GiftCardContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 6px;
    height: 110px;
    box-sizing: border-box;
`;

export const GiftCardBorder = styled.div`
    border-radius: 8px;

    @media (min-width: 380px) {
        box-shadow:
            0px 1px 3px rgba(0, 0, 0, 0.2),
            0px 1px 1px rgba(0, 0, 0, 0.14),
            0px 0px 0px rgba(0, 0, 0, 0.12);
    }
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        text-decoration: none;
    }

    img {
        object-fit: contain;
        border-radius: 4px;
    }
`;

export const GifCardSegementGrid = styled.div(
    () => css`
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(165px, 1fr));
        gap: 10px;
        border-radius: 8px;
    `,
);
